import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    constructor() {}
    public sessionData: any;
    /*********** LocalStorage Set start  ***************/
    set(key: string, data: any): void {
        try {
            data = JSON.stringify(data);
            //let encodedData = window.btoa(unescape(encodeURIComponent(data)))
            localStorage.setItem(key, data);
        } catch (e) {
            console.error('Error saving to localStorage', e);
        }
    }
    /*********** LocalStorage Set end  ***************/
    /*********** LocalStorage Get start  ***************/
    get(key: string) {
        try {
            let decodedData: any;
            const user = localStorage.getItem(key);
            if (user) {
                //decodedData = atob(localStorage.getItem(key));
                decodedData = localStorage.getItem(key);
                decodedData = JSON.parse(decodedData);
            } else {
                decodedData = localStorage.getItem(key);
            }
            if (typeof decodedData == 'object') {
                return decodedData;
            }
            if (typeof decodedData == 'string') {
                return decodedData;
            }
            if (typeof decodedData == 'boolean') {
                return decodedData;
            }
            if (typeof decodedData == 'number') {
                return decodedData;
            }
        } catch (e) {
            console.error('Error getting data from localStorage', e);
            return null;
        }
    }
    /*********** LocalStorage Get end  ***************/
    /*********** LocalStorage remove start  ***************/
    removeItem(key: string) {
        localStorage.removeItem(key);
    }
    /*********** LocalStorage remove end***************/
    /*********** LocalStorage clear start  ***************/
    clear() {
        // "Remember me" only needs the email address to prefill the login form.
        // Deliberately not carried across a logout:
        //   - 'pass', which held the password in cleartext;
        //   - 'userData', which carries the session token and session UID, and
        //     so left a usable credential readable in the browser after the
        //     user had logged out.
        const isChecked = localStorage.getItem('isChecked');
        const rememberedEmail =
            localStorage.getItem('rememberedEmail') ??
            this.readEmailFromUserData();

        localStorage.clear();

        if (isChecked) {
            localStorage.setItem('isChecked', isChecked);
            if (rememberedEmail) {
                localStorage.setItem('rememberedEmail', rememberedEmail);
            }
        }
    }

    /**
     * Recovers the remembered email for users whose browser still holds the
     * pre-fix shape, where the email was only available inside 'userData'.
     */
    private readEmailFromUserData(): string | null {
        try {
            const raw = localStorage.getItem('userData');
            const email = raw ? JSON.parse(raw)?.email : null;
            return typeof email === 'string' ? JSON.stringify(email) : null;
        } catch {
            return null;
        }
    }
    /*********** LocalStorage clear end  ***************/
    /*********** LocalStorage checkSession start  ***************/
    checkSession() {
        let decodedData: any;
        const data = localStorage.getItem('userData');
        if (data) {
            //decodedData = atob(unescape(encodeURIComponent(data)));
            decodedData = data;
        } else {
            decodedData = localStorage.getItem('userData');
        }
        const user = JSON.parse(decodedData);
        if (user) {
            return true;
        } else {
            return false;
        }
    }
    /*********** LocalStorage checkSession end  ***************/
}
